export default __webpack_public_path__ + "static/media/login-background.fa65314f.png";